import React, { useState, useEffect } from 'react'
import classes from './Signup.module.css'
import { motion } from 'framer-motion'
import { useAuth } from '../Context/AuthContext'
import { useHistory } from 'react-router-dom'
import { CircularProgress } from '@material-ui/core'


function Signup({ showSignin }) {

    const { logIn, setLoggedIn } = useAuth();
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    useEffect(() => {
        setPassword('')
        setEmail('');

    }, [])
    async function submitHandler(e) {
        e.preventDefault()
        try {
            setLoading(true);
            await logIn(email, password).then(
                (user) => {
                    setEmail('')
                    setPassword('')
                    setLoggedIn(true)
                    history.push("/")



                })
            // .catch(error => {
            //     setError(error)
            // })
        }
        catch {
            setError("Cannot log in")
        }
        setLoading(false);
    }
    const goToDashBoard = () => {
        history.push("/")
    }





    return (

        <motion.form className={classes.form} initial={{ y: "-100vh", x: "-100vh" }}
            animate={{ y: "-50%", x: "-50%" }}>

            <div className={classes.header}>
                <h1>Login</h1>
                <button className={classes.close} onClick={goToDashBoard}>X</button>
            </div>
            {error && <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className={classes.error}>{error}</motion.div>}
            {loading && <CircularProgress className={classes.progress} />}

            <label htmlFor="email">Email</label>
            <input type="email" id="email" placeholder="Email" required onChange={(e) => setEmail(e.target.value)} />
            <label htmlFor="password">Password</label>
            <input type="password" id="password" placeholder="Password" required onChange={(e) => setPassword(e.target.value)} />
            <button type="submit" className={classes.submit} onClick={submitHandler}>Login</button>

        </motion.form>
    )
}

export default Signup
